export const createSession = async (idToken: string) => {
  const formData = new FormData();
  formData.append('intent', 'login');
  formData.append('idToken', idToken);

  const response = await fetch('/api/auth/session', {
    method: 'POST',
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Failed to create session');
  }
};

export const clearSession = async (context = 'auth') => {
  const formData = new FormData();
  formData.append('intent', 'logout');

  try {
    const response = await fetch('/api/auth/session', {
      method: 'POST',
      body: formData,
    });
    if (!response.ok) {
      console.error(`Failed to clear session cookie during ${context}:`, response.status);
    }
  } catch (error) {
    console.error(`Failed to clear session cookie during ${context}:`, error);
  }
};
